import type { DemoKey } from './keys';

export const zh: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': '几何 · 3D',
  'panel.figure': '图形',
  'panel.dims': '尺寸',
  'panel.style': '外观',
  'panel.lines': '特殊线条',
  'style.body': '主体',
  'style.line': '线条',
  'style.cut': '截面',
  'style.labels': '顶点标签',
  'group.face': '面对角线 / 母线',
  'group.space': '对角线 / 轴 / 中线',
  'split.label': '截切',
  'btn.animate': '动画',
  'btn.reset': '重置',
  'hint.line1': '拖动旋转 · 滚动缩放',
  'hint.line2': '点击线条进行选择',
  'fig.cuboid': '长方体',
  'fig.cube': '立方体',
  'fig.triPrism': '三棱柱',
  'fig.hexPrism': '六棱柱',
  'fig.tetrahedron': '四面体',
  'fig.squarePyramid': '四棱锥',
  'fig.cylinder': '圆柱',
  'fig.cone': '圆锥',
  'fig.sphere': '球体',
  'fig.frustumPyramid': '棱台',
  'fig.frustumCone': '圆台',
  'dim.length': '长',
  'dim.width': '宽',
  'dim.height': '高',
  'dim.side': '边',
  'dim.radius': '半径',
  'dim.r1': '下底半径',
  'dim.r2': '上底半径',
  'dim.sideBase': '底边',
  'dim.sideTop': '顶边',
  'info.face': '面',
  'info.center': '过中心',
  'info.diagonal': '对角线',
  'info.axial': '轴对角线',
  'info.diameter': '直径',
  'info.generator': '母线',
  'info.axis': '轴',
  'info.height': '高',
  'info.median': '中线',
  'info.apothem': '底心距',
  'info.diameterBase': '底面直径',
  'info.diameterTop': '顶面直径',
};
